import React, { useState } from 'react';
import {
  validateMobileNumber,
  validateOTP,
  validateTOTP,
  getTOTPSecret
} from '../services/authService';

const DebugAuth = () => {
  const [mobile, setMobile] = useState('+91-9910952142');
  const [otp, setOtp] = useState('220922');
  const [totp, setTotp] = useState('');
  const [result, setResult] = useState(null);

  const handleTest = () => {
    const mobileResult = validateMobileNumber(mobile);
    const otpResult = validateOTP(otp);
    const totpSecret = getTOTPSecret();

    setResult({
      mobileValidation: mobileResult,
      otpValidation: otpResult,
      totpSecret: totpSecret,
      message: 'New MFA system - use mobile/OTP/TOTP flow'
    });
  };

  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <h1>Authentication Debug Tool</h1>
      
      <div style={{ marginBottom: '20px', padding: '15px', backgroundColor: '#f0f0f0', borderRadius: '5px' }}>
        <h3>Correct Credentials (MFA System):</h3>
        <p><strong>Mobile:</strong> +91-9910952142</p>
        <p><strong>OTP:</strong> 220922</p>
        <p><strong>TOTP:</strong> Use authenticator app</p>
      </div>

      <div style={{ marginBottom: '20px' }}>
        <label style={{ display: 'block', marginBottom: '5px' }}>Mobile:</label>
        <input
          type="tel"
          value={mobile}
          onChange={(e) => setMobile(e.target.value)}
          style={{ width: '100%', padding: '8px', marginBottom: '10px' }}
        />

        <label style={{ display: 'block', marginBottom: '5px' }}>OTP:</label>
        <input
          type="text"
          value={otp}
          onChange={(e) => setOtp(e.target.value)}
          style={{ width: '100%', padding: '8px', marginBottom: '10px' }}
        />

        <label style={{ display: 'block', marginBottom: '5px' }}>TOTP Code (optional):</label>
        <input
          type="text"
          value={totp}
          onChange={(e) => setTotp(e.target.value)}
          style={{ width: '100%', padding: '8px', marginBottom: '10px' }}
        />
        
        <button 
          onClick={handleTest}
          style={{ padding: '10px 20px', backgroundColor: '#007bff', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
        >
          Test Authentication
        </button>
      </div>

      {result && (
        <div style={{ marginTop: '20px' }}>
          <h3>Debug Results:</h3>
          <pre style={{ backgroundColor: '#f8f9fa', padding: '15px', borderRadius: '5px', overflow: 'auto' }}>
            {JSON.stringify(result, null, 2)}
          </pre>
        </div>
      )}
    </div>
  );
};

export default DebugAuth;
